export default "__VITE_ASSET__786663bb__"